import { isRTX } from "app/utils";
import tagsTypes from "../../constants/tagsTypes";

const getCompanyFieldCategory = (organizationName?: string) => {
  if (isRTX(organizationName)) return tagsTypes.BUSINESSES;
  return tagsTypes.COMPANIES;
};

export default getCompanyFieldCategory;
